import { IDeliveryOrdersFilterState } from '@core/state/deliveries/filters/deliveries-filters.state';

export class SearchDeliveryOrdersRequest {
    public filters: IDeliveryOrdersFilterState;
    public sort_by: string[];
}
